module.exports = __webpack_public_path__ + "static/img/logo.2b046879.svg";